/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TicketStatusCount
 */
export interface TicketStatusCount {
    /**
     *
     * @type {string}
     * @memberof TicketStatusCount
     */
    status?: TicketStatusCountStatusEnum;
    /**
     *
     * @type {number}
     * @memberof TicketStatusCount
     */
    count?: number;
}

/**
 * @export
 */
export const TicketStatusCountStatusEnum = {
    Unknown: "Unknown",
    Open: "Open",
    InProgress: "InProgress",
    Escalated: "Escalated",
    Resolved: "Resolved",
} as const;
export type TicketStatusCountStatusEnum =
    (typeof TicketStatusCountStatusEnum)[keyof typeof TicketStatusCountStatusEnum];

/**
 * Check if a given object implements the TicketStatusCount interface.
 */
export function instanceOfTicketStatusCount(
    value: object,
): value is TicketStatusCount {
    return true;
}

export function TicketStatusCountFromJSON(json: any): TicketStatusCount {
    return TicketStatusCountFromJSONTyped(json, false);
}

export function TicketStatusCountFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TicketStatusCount {
    if (json == null) {
        return json;
    }
    return {
        status: json["status"] == null ? undefined : json["status"],
        count: json["count"] == null ? undefined : json["count"],
    };
}

export function TicketStatusCountToJSON(value?: TicketStatusCount | null): any {
    if (value == null) {
        return value;
    }
    return {
        status: value["status"],
        count: value["count"],
    };
}
